module.exports = __webpack_public_path__ + "img/25_19.53a8705c.png";